export default __webpack_public_path__ + "static/data-vis-custom-chart-colors-light-ef71ec3445b7fdd858d6a305bfa0b0ed.png";